import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import {
  apiURL,
  formatDate,
  archiveUrl,
} from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const ModalOrderStatusArchive = ({
  customerNumber,
  workOrderNumber,
  openModalOrderConfirmationMailer,
}) => {
  const { t } = useTranslation()

  const Fdata = new FormData()
  Fdata.append('order_status_archive[customer_number]', customerNumber)
  Fdata.append('order_status_archive[work_order_number]', workOrderNumber)
  const { data, loading, error } = useAxiosPartnerPortal(
    // die Parameter "customerNumber" und "workOrderNumber" werden in der
    //    apiURL eigentlich nicht benötigt
    //    => sie werden hier nur reingegeben, damit sich die URL beim Klick auf
    //       eine andere Bestellung verändert und der axiosHook ausgeführt wird
    apiURL(
      'order_status_archive?c=' + customerNumber + '&w=' + workOrderNumber
    ),
    Fdata,
    'post'
  )

  return (
    <div data-spa-type="order_status_archive">
      <div data-spa-result-for="order_status_archive">
        {loading && <LoadingSpinner />}
        {data && (
          <table className="table table-condensed table-striped">
            <thead>
              <tr>
                <th style={{ width: '20%' }}>{t('generic.spa.date')}</th>
                <th>{t('generic.spa.options')}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{formatDate(row.datum)}</td>
                  <td>
                    <>
                      <a href={archiveUrl(row.archivobject, row.kundennr)}>
                        <i className="fa fa-download"></i>
                      </a>
                      &nbsp;
                      <a
                        href="#"
                        onClick={() =>
                          openModalOrderConfirmationMailer(
                            row.kundennr,
                            row.archivobject
                          )
                        }
                      >
                        <i className="fa fa-envelope"></i>
                      </a>
                    </>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

export default ModalOrderStatusArchive
